var _style, _path, _path2, _path3, _rect, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnfleet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 385.4 55",
    style: {
      enableBackground: "new 0 0 385.4 55"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#4B595E;}\n\t.st1{fill:url(#SVGID_1_);}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M162.2,15.2c-10.7,0-19.4,8.7-19.4,19.4c0,10.7,8.7,19.4,19.4,19.4c10.7,0,19.4-8.7,19.4-19.4 C181.6,23.9,172.9,15.2,162.2,15.2L162.2,15.2z M162.2,50.3c-8.7,0-15.7-7.1-15.7-15.7c0-8.7,7.1-15.7,15.7-15.7 c8.7,0,15.7,7.1,15.7,15.7C178,43.2,170.9,50.3,162.2,50.3z M315.4,33.4c-0.5-10.1-8.9-18.1-19.1-18.1c-10.5,0-19.1,8.6-19.1,19.1 c0,10.5,8.6,19.1,19.1,19.1c6.2,0,12.5-3,16-7.7l-2.9-2.2c-2.8,3.8-8,6.2-13.1,6.2c-8.3,0-15-6.5-15.5-14.6h34.7L315.4,33.4z  M281.1,31.7c1.3-7.2,7.7-12.7,15.3-12.7c7.6,0,14,5.5,15.3,12.7H281.1z M359.9,33.4c-0.5-10.1-8.9-18.1-19.1-18.1 c-10.5,0-19.1,8.6-19.1,19.1c0,10.5,8.6,19.1,19.1,19.1c6.2,0,12.5-3,16-7.7l-2.9-2.2c-2.8,3.8-8,6.2-13.1,6.2 c-8.3,0-15-6.5-15.5-14.6H360L359.9,33.4z M325.5,31.7c1.3-7.2,7.7-12.7,15.3-12.7c7.6,0,14,5.5,15.3,12.7H325.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M243.7,3.6c-4.5,4.6-4.4,11.9-4.4,12.2v1h-6.8v3.8h6.8v32.3h3.8V20.6h13v-3.8h-13v-1.1c0-0.1-0.1-6,3.3-9.5 c1.6-1.7,3.8-2.5,6.5-2.5h3.1V0H253C249.2,0,246.1,1.2,243.7,3.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M375.6,20.6h9.9v-3.8h-9.9V5h-3.8v11.8H364v3.8h7.8l0,17.5c0,0.3-0.1,7.4,4.3,11.9c2.4,2.4,5.5,3.6,9.3,3.6 v-3.8c-2.8,0-5-0.8-6.6-2.5c-3.3-3.4-3.3-9.2-3.3-9.3V20.6z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 264.4,
    y: 0.3,
    className: "st0",
    width: 3.8,
    height: 52.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M207.3,15.6c-10,0-18.2,8.1-18.2,18.2v19.4h3.8V33.7c0-7.9,6.5-14.4,14.4-14.4c7.9,0,14.4,6.5,14.4,14.4v19.4 h3.8V33.7C225.4,23.7,217.3,15.6,207.3,15.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -202.4261,
    y1: 342.0511,
    x2: -202.4261,
    y2: 341.2125,
    gradientTransform: "matrix(129.0438 0 0 -60.0062 26175.9492 20529.9121)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#33B1F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AA81F3"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59,34.2c0,0,0.8,0.7,2.3,2.1c1.5,1.4,3.7,3.3,6.7,5.7c3,2.3,6.8,4.9,11.4,6.9 c2.3,0.9,4.9,1.7,7.5,1.8c1.3,0,2.6,0,3.9-0.4c0.6-0.1,1.2-0.4,1.9-0.6c0.6-0.3,1.2-0.6,1.7-1c1.1-0.8,2.1-1.7,3-2.8 c0.9-1.1,1.6-2.4,2.3-3.8c1.2-2.8,1.9-6.1,2.1-9.4c0.2-3.4-0.3-6.8-1.3-10.1c-1.1-3.2-2.9-6.2-5.4-7.9c-2.5-1.8-5.5-2.4-8.9-1.9 c-1.7,0.3-3.4,0.7-5.1,1.5c-0.9,0.3-1.7,0.8-2.6,1.2c-0.8,0.5-1.7,0.9-2.5,1.4c-3.4,2-6.6,4.5-9.7,7.2c-1.5,1.4-3.1,2.8-4.6,4.3 c-0.8,0.7-1.5,1.5-2.2,2.2l-2.2,2.3c-2.9,3.1-6.2,6.3-9.6,9.3c-3.4,2.9-7.1,5.6-11,8c-4,2.3-8.4,4.2-13.3,4.9 c-2.4,0.3-5.1,0.3-7.6-0.3c-2.5-0.6-5-1.8-6.9-3.4c-2-1.6-3.6-3.5-4.8-5.5c-1.2-2-2.1-4.1-2.7-6.3c-0.6-2.1-0.9-4.3-1.1-6.4 c-0.2-2.1-0.1-4.2,0.1-6.2c0.4-4,1.5-7.9,3.3-11.4c0.9-1.7,2-3.3,3.3-4.8C8.2,9.2,9.7,7.9,11.4,7c1.6-1,3.5-1.6,5.2-1.9 c1.8-0.4,3.5-0.3,5.2-0.1c3.3,0.4,6.1,1.6,8.6,2.9c4.9,2.6,8.4,5.8,11.1,8.5c2.7,2.7,4.6,5,5.9,6.6c1.3,1.6,1.9,2.4,1.9,2.4 s-0.8-0.7-2.3-2.1c-1.5-1.4-3.7-3.3-6.7-5.7c-3-2.3-6.8-4.9-11.4-6.8c-2.3-0.9-4.9-1.7-7.5-1.7c-2.6,0-5.3,0.5-7.5,2.1 c-1.1,0.8-2.1,1.7-3,2.9c-0.9,1.1-1.6,2.4-2.3,3.9c-1.2,2.8-2,6.1-2.1,9.4c-0.2,3.3,0.2,6.8,1.3,10.1c1.1,3.2,2.9,6.2,5.3,7.9 c2.4,1.8,5.5,2.4,8.9,1.8c0.4,0,0.8-0.2,1.3-0.3c0.4-0.1,0.9-0.2,1.3-0.3l1.3-0.4l1.3-0.5c0.4-0.2,0.9-0.3,1.3-0.6l1.3-0.6 c0.8-0.5,1.7-0.9,2.5-1.4c3.4-2,6.6-4.5,9.7-7.2c3.1-2.8,6-5.6,9-8.8l2.3-2.3c0.8-0.8,1.6-1.6,2.4-2.4c1.6-1.6,3.3-3.1,4.9-4.6 c3.4-2.9,7.1-5.6,11.1-8c4-2.3,8.4-4.2,13.3-4.8c2.5-0.3,5.1-0.2,7.6,0.4c2.5,0.6,4.9,1.8,6.9,3.4c2,1.6,3.6,3.5,4.8,5.5 c1.2,2,2.1,4.1,2.7,6.3c0.6,2.1,0.9,4.2,1.1,6.3c0.2,2.1,0.1,4.2-0.1,6.2c-0.4,4-1.5,7.9-3.3,11.4c-0.9,1.7-2,3.3-3.3,4.8 c-1.3,1.4-2.8,2.7-4.5,3.6c-0.8,0.5-1.7,0.8-2.6,1.2c-0.9,0.3-1.8,0.6-2.7,0.7c-1.8,0.3-3.5,0.3-5.2,0.1c-3.3-0.5-6.1-1.6-8.5-2.9 c-4.9-2.7-8.4-5.8-11.1-8.5c-2.7-2.7-4.6-5-5.9-6.6C59.6,35.1,59,34.2,59,34.2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnfleet);
export default __webpack_public_path__ + "static/media/onfleet.1401d2eba70c1374cf554408ab04e3f3.svg";
export { ForwardRef as ReactComponent };